module.exports = __webpack_public_path__ + "static/media/wedding.bdb26bb1.jpg";